import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromQuotes from '../../../quotes/reducers';
import * as LayoutActions from '../../../core/actions/layout.actions';
import * as fromProducts from '../../reducers'
import {Observable} from 'rxjs';
import {Attribute} from '../../models/attribute';
import {SearchFilter} from 'src/app/shared/components/advanced-searchbox/advanced-searchbox.component';
import * as CollectionActions from '../../../products/actions/collection.actions';
import {LoadCollectionCommand} from '../../models/product-commands';

@Component({
    selector: 'app-advanced-search-page',
    templateUrl: './advanced-search-page.component.html',
    styleUrls: ['./advanced-search-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedSearchPageComponent implements OnInit{
    attributes$: Observable<Attribute[]>;
    searchFilters$: Observable<SearchFilter[]>;

    decorTypeOpen$: Observable<boolean>;
    productTypeOpen$: Observable<boolean>;
    occasionTypeOpen$: Observable<boolean>;
    purposeTypeOpen$: Observable<boolean>;
    productCategoryTypeOpen$: Observable<boolean>;
    colorTypeOpen$: Observable<boolean>;
    sortTypeOpen$: Observable<boolean>;

    constructor(private store: Store<fromQuotes.State>) {}

    ngOnInit(): void {
        this.attributes$ = this.store.pipe(select(fromProducts.getAttributes));
        this.searchFilters$ = this.store.pipe(select(fromProducts.getSearchFilters));
        this.decorTypeOpen$ = this.store.pipe(select(fromProducts.getDecorTypeSubMenuOpen));
        this.productTypeOpen$ = this.store.pipe(select(fromProducts.getProductTypeSubMenuOpen));
        this.occasionTypeOpen$ = this.store.pipe(select(fromProducts.getOccasionTypeSubMenuOpen));
        this.purposeTypeOpen$ = this.store.pipe(select(fromProducts.getPurposeTypeSubMenuOpen));
        this.productCategoryTypeOpen$ = this.store.pipe(select(fromProducts.getProductCategoryTypeSubMenuOpen));
        this.colorTypeOpen$ = this.store.pipe(select(fromProducts.getColorTypeSubMenuOpen));
        this.sortTypeOpen$ = this.store.pipe(select(fromProducts.getSortTypeSubMenuOpen));
    }


    onCloseAdvancedSearchPage() {
        this.store.dispatch(LayoutActions.closeAdvancedSearch());
    }

    search(loadCollectionCommand: LoadCollectionCommand) {
        this.store.dispatch(CollectionActions.load({command: loadCollectionCommand}));
    }
}
